import validate from "/builds/aschehoug/aschehoug-utdanning/vgs-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import license_45check_45global from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/middleware/license-check.global.ts";
import set_45page_45title_45global from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/middleware/setPageTitle.global.ts";
import manifest_45route_45rule from "/builds/aschehoug/aschehoug-utdanning/vgs-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  license_45check_45global,
  set_45page_45title_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}